const sourcesPictures = {
    1: 'AOS',
    2: 'Auto360',
    3: 'Stampyt',
};

export default sourcesPictures;
